module.exports = "<div class=progress ng-attr-title=\"{{$ctrl.percent||'0'}}%\"><div class=progress-bar role=progressbar ng-style=$ctrl.getStyles() ng-attr-aria-valuenow={{$ctrl.percent}} aria-valuemin=0 aria-valuemax=100></div></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-progress-bar/gmc-progress-bar.component.html
// module id = 867
// module chunks = 31